var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Loader, Message } from "semantic-ui-react";
import { deleteWithAuthn } from "../RequestHelpers";
var DeleteKitConfirmation = /** @class */ (function (_super) {
    __extends(DeleteKitConfirmation, _super);
    function DeleteKitConfirmation(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                deleteWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/items/id/" + _this.props.itemId)
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't delete kit: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
        };
        return _this;
    }
    DeleteKitConfirmation.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement("p", null, "Are you sure you want to delete the kit?"),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Kit deleted."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Kit could not be deleted."),
            React.createElement(Button, { disabled: this.state.success, icon: 'trash', label: 'Delete', labelPosition: 'left', onClick: this.submit, negative: true }));
    };
    return DeleteKitConfirmation;
}(React.PureComponent));
export { DeleteKitConfirmation };
//# sourceMappingURL=DeleteKitConfirmation.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/DeleteKitConfirmation.js
// module id = 1255
// module chunks = 0